import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';

@Component
export default class EpicMobileHeader extends Vue {
    public title: string = 'EpicMobileHeader';

    public configs = new CommonConfig();

    public maxHeight = '450px';


    public showCondition: boolean = false;
    public mobileMenuVisble: boolean = false;
    public buyMenuVisble: boolean = false;
    public sellMenuVisble: boolean = false;
    public avatarUri = this.configs.epicLogo;
    public menuUri = `${this.configs.rifoDesignAssetsUrl}/menu.png`;
    public profileUri = `${this.configs.rifoDesignAssetsUrl}/profile.png`;
    @Watch('$route.fullPath', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
        this.showCondition = this.$route.fullPath === '/';
    }

    public toggleBuyMenu() {
        this.buyMenuVisble = !this.buyMenuVisble;
    }
    public toggleSellMenu() {
        this.sellMenuVisble = !this.sellMenuVisble;
    }
    public mobileMenuOpen() {
        this.mobileMenuVisble = true;
    }
    public mobileMenuClose() {
        this.mobileMenuVisble = false;
    }
    public created() {
    }

    public getRifoDesignAssets(str: string = '') {
        return `${this.configs.rifoDesignAssetsUrl}${str}`;
    }

    public handleSignButton() {
        this.$store.commit('bgBlurOn');
    }

}
